import noop from 'lodash/fp/noop';
import { FC } from 'react';

import Content, { ModalWrapper } from './Wrapper';

export type SubscriptionModalProps = {
  onModalClose?: () => void;
};

const SubscriptionModal: FC<SubscriptionModalProps> = ({ children, onModalClose = noop }) => (
  <ModalWrapper cardSettings={{ isPadding: false }} isCloseButtonInsideModal={true} onModalClose={onModalClose}>
    <Content>{children}</Content>
  </ModalWrapper>
);

export default SubscriptionModal;
